import { Box, Button, Text } from '@domain-group/suit-theme'

import useAdCopy from '@hooks/useAdCopy'
import useCampaign from '@hooks/useCampaign'

import { confirmAction } from '@functions/entity'

import type { AdCopyModel } from '@models/types'
import type { AdCopyOrderItemModel } from '../../../hooks/useImportProjectAdCopies'

interface OrderItemProps {
  orderItem: AdCopyOrderItemModel,
}

const OrderItem = (props: OrderItemProps) => {
  const { orderItem } = props

  const {
    ad_copies, campaign_id, options_string, provider_id, service, title,
  } = orderItem

  const adCopyIds = ad_copies.map((adCopy: AdCopyModel) => adCopy.id)

  const showImportButton = ad_copies.some(adCopy => !adCopy.copied_to_campaign)

  const { callbacks: { reviewAdCopy } } = useCampaign({ id: campaign_id })
  const { callbacks: { assignAdCopiesToCampaign } } = useAdCopy(ad_copies?.[0])

  if (!ad_copies?.length) return null

  const confirmActionPayload = {
    callbacks: {
      actionFn: assignAdCopiesToCampaign,
    },
    options: {
      entityParams: {
        ad_copy_ids: adCopyIds,
        campaign_id,
      },
      confirmButtonColor: '#43ac6a',
      icon: 'success' as const,
    },
    strings: {
      actionString: 'add to',
      confirmString: 'Are you sure? This will overwrite any existing ad copy and cannot be undone.',
      entityName: 'campaign',
      toastText: 'Ad Copies Added to Campaign',
    },
  }

  return (
    <Box flexDirection={['column', 'row']} marginBottom="large" padding="large" variant="white">
      <Box flexDirection="column" maxWidth={['100%', '50%']}>
        <Text fontSize="small" variant="ellipsis">{service?.title || `Service #${service?.id}`}</Text>

        <Text
          color="bodyFontLightColor"
          fontSize="xsmall"
          marginTop="small"
          variant="ellipsis"
        >
          {`${title} ${options_string}`}
        </Text>
      </Box>

      <Box
        flexDirection={['column', 'row']}
        justifyContent="flex-end"
        marginLeft={[0, 'large']}
        marginTop={['large', 0]}
      >
        {showImportButton && (
          <Button
            buttonStyle="secondaryEdit"
            onClick={() => confirmAction(confirmActionPayload)}
            // @ts-expect-error TS2322
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Import ({ad_copies?.length})
          </Button>
        )}

        <Button
          as="a"
          buttonStyle="primaryEdit"
          onClick={() => reviewAdCopy(orderItem, { id: provider_id })}
          marginLeft={[0, 'medium']}
          marginTop={['medium', 0]}
          // @ts-expect-error TS2322
          size={['medium', 'small']}
          target="_blank"
          width={['100%', 'fit-content']}
        >
          View Ad Copy
        </Button>
      </Box>
    </Box>
  )
}

export default OrderItem
